// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// @material-ui/icons
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import MusicNoteIcon from '@material-ui/icons/MusicNote';
import MicIcon from '@material-ui/icons/Mic';
import StarsIcon from '@material-ui/icons/Stars';
// page styles
import blogStyle from 'assets/jss/material-kit-pro-react/views/landingPageSections/blogStyle.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
// core components
import Button from 'components/CustomButtons/Button.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
// react components for routing our app without refresh
import { graphql, Link, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

const useStyles = makeStyles(blogStyle);

export default function SectionBlog() {
  const {
    laurenAlainaBlogImage,
    markReitzAwardBlogImage,
    sonOfAGunBlogImage,
  } = useStaticQuery(graphql`
    query getBlogImages {
      laurenAlainaBlogImage: file(
        relativePath: { eq: "blog/lauren-alaina-blog.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      markReitzAwardBlogImage: file(
        relativePath: { eq: "blog/mark-reitz-award-2022.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      sonOfAGunBlogImage: file(
        relativePath: { eq: "lineup/2025/son-of-a-gun.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
  `);
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <h2 className={classes.blogTitle}>Chilimania News</h2>
        <br />
        <GridContainer className={classes.blogContainer}>
          <GridItem xs={12} sm={8} md={4}>
            <Card className={classes.marginTop0} plain>
              <CardHeader plain image>
                <GatsbyImage
                  image={laurenAlainaBlogImage.childImageSharp.gatsbyImageData}
                  className={classes.blogImage}
                  alt="Blog Post 1"
                />
              </CardHeader>
              <CardBody plain>
                <h6 className={classes.blogCategory}>
                  <MusicNoteIcon className={classes.blogIcon} />
                  Music
                </h6>
                <h4 className={classes.cardTitle}>
                  Lauren Alaina Headlining Country Edge 2025
                </h4>
                <p className={classes.blogDescription}>
                  For our 2025 Country Edge headliner, we are thrilled to
                  announce Lauren Alaina! Alaina is a country music singer and
                  songwriter who gained fame as a finalist on the tenth season
                  of American Idol. She has released several successful albums
                  and singles, earning multiple awards and nominations in the
                  country music industry.
                </p>
                <Link to="/news">
                  <Button color="primary" size="sm">
                    Read More
                    <ChevronRightIcon className={classes.blogIcons} />
                  </Button>
                </Link>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={8} md={4}>
            <Card className={classes.marginTop0} plain>
              <CardHeader plain image>
                <GatsbyImage
                  image={sonOfAGunBlogImage.childImageSharp.gatsbyImageData}
                  imgStyle={{ objectFit: 'fill' }}
                  className={classes.blogImage}
                  alt="Blog Post 2"
                />
              </CardHeader>
              <CardBody plain>
                <h6 className={classes.blogCategory}>
                  <MusicNoteIcon className={classes.blogIcon} />
                  Music
                </h6>
                <h4 className={classes.cardTitle}>
                  Announcing Chilimania's 2025 Headliner: Son of a Gun
                </h4>
                <p className={classes.blogDescription}>
                  We are excited to announce that Son of a Gun will be
                  headlining Chilimania 2025! They are known for being the best
                  Guns N’ Roses tribute band on planet earth and are fronted by
                  Ari Kamin, lead singer of Steven Adler of Guns N’ Roses. This
                  five piece Rock N’ Roll band based in Los Angeles is able to
                  bring a stadium show to any kind of venue.
                </p>
                <Link to="/news">
                  <Button color="primary" size="sm">
                    Read More
                    <ChevronRightIcon className={classes.blogIcons} />
                  </Button>
                </Link>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={8} md={4}>
            <Card className={classes.marginTop0} plain>
              <CardHeader plain image>
                <GatsbyImage
                  image={
                    markReitzAwardBlogImage.childImageSharp.gatsbyImageData
                  }
                  imgStyle={{ objectFit: 'fill' }}
                  className={classes.blogImage}
                  alt="Blog Post 3"
                />
              </CardHeader>
              <CardBody plain>
                <h6 className={classes.blogCategory}>
                  <StarsIcon className={classes.blogIcon} />
                  Award
                </h6>
                <h4 className={classes.cardTitle}>
                  2022 Mark Reitz Award Recipient: Dan Hinrichs
                </h4>
                <p className={classes.blogDescription}>
                  This year's wonderful and well-deserved recipient of the Mark
                  Reitz Award is Dan Hinrichs. Dan has been volunteering at
                  Chilimania for the past four years, but proudly hasn't missed
                  the event in 18 years. Click below to view the full story.
                </p>
                <Link to="/news">
                  <Button color="primary" size="sm">
                    Read More
                    <ChevronRightIcon className={classes.blogIcons} />
                  </Button>
                </Link>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
